module.exports = __webpack_public_path__ + "static/media/MR.20dfa3b5.png";